// src/components/Hero.jsx

import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

import fondo from "../assets/aldis.jpeg";
import aldana from "../assets/aldana.png";
import selena from "../assets/selena.png";

const Hero = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.18,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 30 },
    show: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.9, ease: "easeOut" },
    },
  };

  const buttons = [
    {
      title: "RESERVAS",
      cta: "Entrar",
      path: "/reservas",
    },
    {
      title: "MENTORÍAS",
      cta: "Descubrir",
      path: "/mentorias",
    },
    {
      title: "PRÓXIMOS DESTINOS",
      cta: "Ver destinos",
      path: "/destinos",
    },
  ];

  return (
    <section className="relative min-h-[100svh] sm:min-h-screen w-full flex items-center justify-center overflow-hidden px-6 py-24">
      {/* BACKGROUND — ajustado para que se recorte bien en mobile */}
      <img
        src={fondo}
        alt="Aldana Selena"
        className="
          absolute inset-0
          w-full h-full
          object-cover
          object-[68%_center]
          sm:object-center
        "
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-[#0E0B09]/80 backdrop-blur-[2px]" />

      {/* CONTENT */}
      <motion.div
        variants={container}
        initial="hidden"
        animate="show"
        className="relative z-10 w-full max-w-[1100px] flex flex-col items-center text-center"
      >
        {/* TITLE — imágenes "aldana" + "selena" en vez de texto */}
        <motion.div
          variants={item}
          className="flex flex-row items-center justify-center pt-4 gap-3 sm:gap-4 md:gap-5"
        >
          <img
            src={aldana}
            alt="Aldana"
            className="h-[9vw] max-h-14 sm:h-16 sm:max-h-16 md:h-20 md:max-h-20 lg:h-24 lg:max-h-24 w-auto object-contain"
          />
          <img
            src={selena}
            alt="Selena"
            className="h-[9vw] max-h-14 sm:h-16 sm:max-h-16 md:h-20 md:max-h-20 lg:h-24 lg:max-h-24 w-auto object-contain"
          />
        </motion.div>

        {/* EJE DE MARCA — reemplaza el listado de servicios */}
        <motion.p
          variants={item}
          className="mt-5 uppercase text-[#8C6F5A] tracking-[0.35em] text-[9px] sm:text-xs md:text-sm font-light"
        >
          Todo empieza aprendiendo a observar
        </motion.p>

        {/* DIVIDER */}
        <motion.div
          variants={item}
          className="w-20 h-px bg-[#8C6F5A]/40 my-10"
        />

        {/* BUTTON GRID — baja prioridad visual: más chico, más sutil */}
        <motion.div
          variants={item}
          className="w-full grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-4 opacity-90"
        >
          {buttons.map((button, index) => (
            <Link
              key={index}
              to={button.path}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              className="group flex flex-col items-center gap-3 outline-none focus-visible:ring-1 focus-visible:ring-[#C6A98A]/60 rounded-sm"
            >
              {/* LABEL */}
              <motion.span
                animate={{
                  color: hoveredIndex === index ? "#C6A98A" : "#8C6F5A",
                  letterSpacing: hoveredIndex === index ? "0.3em" : "0.22em",
                }}
                transition={{ duration: 0.35, ease: "easeOut" }}
                className="uppercase font-light text-[9px] sm:text-[10px]"
              >
                {button.title}
              </motion.span>

              {/* CTA BUTTON */}
              <div className="relative overflow-hidden">
                {/* border lines that draw on hover */}
                <motion.span
                  aria-hidden="true"
                  className="pointer-events-none absolute inset-0"
                >
                  {/* top */}
                  <motion.span
                    className="absolute top-0 left-0 h-px bg-[#C6A98A]"
                    animate={{ width: hoveredIndex === index ? "100%" : "0%" }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                  />
                  {/* bottom */}
                  <motion.span
                    className="absolute bottom-0 right-0 h-px bg-[#C6A98A]"
                    animate={{ width: hoveredIndex === index ? "100%" : "0%" }}
                    transition={{ duration: 0.3, ease: "easeOut", delay: 0.05 }}
                  />
                  {/* left */}
                  <motion.span
                    className="absolute top-0 left-0 w-px bg-[#C6A98A]"
                    animate={{ height: hoveredIndex === index ? "100%" : "0%" }}
                    transition={{ duration: 0.25, ease: "easeOut", delay: 0.1 }}
                  />
                  {/* right */}
                  <motion.span
                    className="absolute bottom-0 right-0 w-px bg-[#C6A98A]"
                    animate={{ height: hoveredIndex === index ? "100%" : "0%" }}
                    transition={{ duration: 0.25, ease: "easeOut", delay: 0.1 }}
                  />
                </motion.span>

                {/* static dim border always present */}
                <span className="absolute inset-0 border border-[#8C6F5A]/20 pointer-events-none" />

                {/* fill sweep */}
                <motion.span
                  className="absolute inset-0 bg-[#C6A98A]/[0.07] pointer-events-none"
                  animate={{ opacity: hoveredIndex === index ? 1 : 0 }}
                  transition={{ duration: 0.3 }}
                />

                <motion.span
                  className="relative z-10 flex items-center gap-2 px-6 py-2.5 uppercase tracking-[0.22em] text-[10px] sm:text-[11px] font-light"
                  animate={{
                    color: hoveredIndex === index ? "#E8D8C3" : "#C6A98A",
                  }}
                  transition={{ duration: 0.3 }}
                >
                  <motion.span
                    animate={{ x: hoveredIndex === index ? 3 : 0 }}
                    transition={{ duration: 0.3, ease: "easeOut" }}
                  >
                    →
                  </motion.span>
                  <span>{button.cta}</span>
                </motion.span>
              </div>
            </Link>
          ))}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;